import Cookies from 'js-cookie';
import qs from 'query-string';
import jwtDecode from 'jwt-decode';
import isBrowser from './isBrowser';
import { AUTH_TOKEN_KEY, USER_ID_KEY, X_REFRESH_TOKEN, STAGING_USER_ID_KEY, STAGING_AUTH_TOKEN_KEY, STAGING_X_REFRESH_TOKEN, DEV_AUTH_TOKEN_KEY, DEV_USER_ID_KEY, DEV_X_REFRESH_TOKEN } from './constants';
var HOST_DOMAIN_MAIN = {
  "lvh.me": ".lvh.me",
  "developer.dev.frame.io": ".dev.frame.io",
  "developer.frame.io": ".frame.io",
  "developer.staging.frame.io": ".staging.frame.io"
};

var getDomain = function getDomain() {
  var host = Object.keys(HOST_DOMAIN_MAIN).find(function (k) {
    return k.includes(window.location.hostname);
  });
  return host ? HOST_DOMAIN_MAIN[host] : '';
};

var isDev = function isDev() {
  if (isBrowser() && (window.location.protocol === 'http:' || window.location.origin === 'https://developer.dev.frame.io')) {
    return true;
  }

  return false;
};

var isStaging = function isStaging() {
  if (isBrowser() && (window.location.protocol === 'http:' || window.location.origin === 'https://developer.staging.frame.io')) {
    return true;
  }

  return false;
};

export function inferKeys() {
  var authTokenKey = AUTH_TOKEN_KEY;
  var userIdKey = USER_ID_KEY;
  var refreshTokenKey = X_REFRESH_TOKEN;

  if (isDev()) {
    userIdKey = DEV_USER_ID_KEY, authTokenKey = DEV_AUTH_TOKEN_KEY, refreshTokenKey = DEV_X_REFRESH_TOKEN;
  }

  if (isStaging()) {
    userIdKey = STAGING_USER_ID_KEY, authTokenKey = STAGING_AUTH_TOKEN_KEY, refreshTokenKey = STAGING_X_REFRESH_TOKEN;
  }

  return {
    userIdKey: userIdKey,
    authTokenKey: authTokenKey,
    refreshTokenKey: refreshTokenKey
  };
}
;

var _inferKeys = inferKeys(),
    userIdKey = _inferKeys.userIdKey,
    authTokenKey = _inferKeys.authTokenKey,
    refreshTokenKey = _inferKeys.refreshTokenKey;

var dev = isDev();
var staging = isStaging();
export var redirectToAuthPortal = function redirectToAuthPortal() {
  var authCallbackURI;
  var authCallbackHost;

  if (window.location.protocol === 'http:') {
    // Running locally
    authCallbackHost = 'https://accounts.dev.frame.io';
    authCallbackURI = 'http://lvh.me:8000/auth-callback';
  } else if (window.location.origin === 'https://developer.staging.frame.io') {
    // Running in staging environment
    authCallbackHost = 'https://accounts.staging.frame.io';
    authCallbackURI = 'https://developer.staging.frame.io/auth-callback';
  } else if (window.location.origin === 'https://developer.dev.frame.io') {
    // Running in dev environment
    authCallbackHost = 'https://accounts.dev.frame.io';
    authCallbackURI = 'https://developer.dev.frame.io/auth-callback';
  } else {
    // Running in production
    authCallbackHost = 'https://accounts.frame.io';
    authCallbackURI = 'https://developer.frame.io/auth-callback';
  }

  var params = qs.stringify({
    auth_callback: authCallbackURI,
    redirect_path: window.location.pathname
  });
  window.location.assign("".concat(authCallbackHost, "/welcome?").concat(params));
};
export var handleAuth = function handleAuth(cb) {
  if (!isBrowser()) {
    return;
  }

  var _qs$parse = qs.parse(window.location.hash),
      token = _qs$parse.token,
      refreshToken = _qs$parse.refreshToken,
      userId = _qs$parse.userId;

  var domain = getDomain();
  var opts = {
    expires: 1,
    domain: domain
  };
  Cookies.set(authTokenKey, token, opts);
  Cookies.set(userIdKey, userId, opts);
  Cookies.set(refreshTokenKey, refreshToken, opts);
  cb();
};
export var logout = function logout(cb) {
  var domain = getDomain();
  Cookies.remove(authTokenKey, {
    domain: domain
  });
  Cookies.remove(userIdKey, {
    domain: domain
  });
  Cookies.remove(refreshTokenKey, {
    domain: domain
  });

  if (cb) {
    cb();
  }
};
export var setAuthToken = function setAuthToken(token) {
  var domain = getDomain();
  var opts = {
    expires: 1,
    domain: domain
  };
  Cookies.set(authTokenKey, token, opts);
};
export var getAuthToken = function getAuthToken() {
  return Cookies.get(authTokenKey);
};
export var getRefreshToken = function getRefreshToken() {
  return Cookies.get(refreshTokenKey);
};

function getAuthTokenExpiry(authToken) {
  try {
    var jwtToken = jwtDecode(authToken);
    return new Date(jwtToken.exp * 1000);
  } catch (err) {
    return null;
  }
}

export function hasAuthTokenExpired(authToken) {
  var tokenExpiryDate = getAuthTokenExpiry(authToken);
  return new Date() >= tokenExpiryDate;
}
export var isAuthenticated = function isAuthenticated() {
  return !!getAuthToken();
};